import React, {Fragment} from 'react';
import {Stack} from '@mui/material';
import {CTAButtonFixed} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {BookingScheduledEnum, OdontoBookingTaggingEnum} from 'main/analytics/gaTagsEnum';
import {translations} from 'presentation/translations-new';
import {OdontoConfirmBookingButtonProps} from './types';
import {useOdontoConfirmationBookingButton} from '../../hooks/useOdontoConfirmationBookingButton';
import {OdontoConfirmBookingModals} from '../OdontoConfirmBookingModals';

const {confirmBooking} = translations['pt-br'].privateFlow.bookingFlow;
const {goBack} = translations['pt-br'].commons;

export function OdontoConfirmBookingButton({handleBack}: OdontoConfirmBookingButtonProps) {
	const {
		isMobile,
		handleBookingAction,
		isSubmitting,
		isGenericError,
		isUnauthorized,
		isDone,
		setBookingState,
		hasHourOrAvailabilityError,
	} = useOdontoConfirmationBookingButton();

	return (
		<Fragment>
			<CTAButtonFixed.Root>
				<Stack
					gap={1}
					direction={isMobile ? 'column-reverse' : 'row'}
					justifyContent="flex-end">
					<CTAButtonFixed.Action
						data-tag-id={
							OdontoBookingTaggingEnum.CLICK_VOLTAR_STEP_CONFIRMAR_AGENDAMENTO
						}
						fullWidth={isMobile}
						onClick={handleBack}
						size="large"
						variant="outlined">
						{goBack}
					</CTAButtonFixed.Action>
					<CTAButtonFixed.Action
						data-tag-id={BookingScheduledEnum.CLICK_CONFIRMAR_AGENDAMENTO}
						fullWidth={isMobile}
						onClick={handleBookingAction}
						endIcon={isSubmitting ? <Loading color="inherit" size={16} /> : null}
						disabled={isSubmitting}
						size="large">
						{confirmBooking}
					</CTAButtonFixed.Action>
				</Stack>
			</CTAButtonFixed.Root>

			<OdontoConfirmBookingModals
				isUnauthorized={isUnauthorized}
				isDone={isDone}
				hasHourOrAvailabilityError={hasHourOrAvailabilityError}
				isGenericError={isGenericError}
				setBookingState={setBookingState}
				handleBack={handleBack}
			/>
		</Fragment>
	);
}
